import * as React from "react";
import { TokenValidationContext } from "./TokenValidationProvider";

export const useTokenValidation = () =>
  React.useContext(TokenValidationContext);
